<template>
<div class="chapter">
<div class="inner_page">
<div class="pseudo_margin_1"></div>
<div class="section" id="section008">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<p class="poem_title1" id="ch2"><a id="page_2"></a>2.</p>
<div class="pseudo_margin_2"></div>
<p class="negative_indent_1">Circular the table for eating, around which we talked.</p>
<p class="negative_indent_1">Golden branches vaulted the roads.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">The trip to Colorado had already been planned.</p>
<p class="negative_indent_1">Otherwise, I would never have left.</p>
<p class="negative_indent_1">Maybe you know my friend.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">Spectra inside spectra make cataclysm of day.</p>
<p class="negative_indent_1">Something like that. Disorder in all things.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">Mother, I won’t call to complain anymore.</p>
<p class="negative_indent_1">The geraniums are enormous. Bougainvilleas crowd the walls.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">Given a box, some people imagine a hammer and nails.</p>
<p class="negative_indent_1">In some kinds of poems, the arms are love.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">The day I ran with Dan at the reservoir,</p>
<p class="negative_indent_1">I hated how slow I was, but loved that my lungs could burn.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">Many years ago in school a visiting poet read my poem.</p>
<p class="negative_indent_1">I said I didn’t know what the poem was.</p>
<p class="negative_indent_1">Of course you do, she said.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter002.vue?c40b4c88